import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Business } from '@app/modules/my-business/interfaces/business.interface';
import { MyBusinessApiService } from '@app/modules/my-business/services/my-business.api.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sbnb-edit-business',
  templateUrl: './edit-business.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditBusinessComponent implements OnInit {
  // Dependencies
  private readonly route = inject(ActivatedRoute);
  private readonly myBusinessApiService = inject(MyBusinessApiService);
  private readonly toast = inject(ToastNotificationsService);
  // State
  public business$ = new BehaviorSubject<Business>(null);

  ngOnInit() {
    this.loadBusiness();
  }

  private loadBusiness() {
    this.myBusinessApiService.getBusiness(this.route.snapshot.params['uuid']).subscribe((business) => {
      this.business$.next(business);
    });
  }

  public onSave() {
    this.loadBusiness();
    this.toast.success('Business updated successfully');
  }
}
